import React from 'react';
import './loader.scss';

interface ILoaderProps {
    loadingLabel?: string;
}

const Loader: React.FC<ILoaderProps> = (props) => {
  return (
    <div className="d-flex justify-content-center">
      <div className="spinner-telenor" role="status">
        <span className="visually-hidden">{props.loadingLabel}</span>
      </div>
    </div>
  );
};

export default Loader;
